"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault")["default"];

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _objectSpread2 = _interopRequireDefault(require("@babel/runtime/helpers/esm/objectSpread2"));

var _app = require("@package/app");

var _moment = _interopRequireDefault(require("@package/moment"));

var _utils = require("@package/utils");

var _react = _interopRequireDefault(require("react"));

var _reactRouterDom = require("react-router-dom");

var _Form = _interopRequireDefault(require("./Form"));

function Filter() {
  try {
    var handleSubmit = function handleSubmit(formData) {
      navigate((0, _utils.objectToQuery)((0, _objectSpread2["default"])((0, _objectSpread2["default"])((0, _objectSpread2["default"])({}, query), formData), {}, {
        page: 1
      })));
    };

    var navigate = (0, _reactRouterDom.useNavigate)();
    var location = (0, _reactRouterDom.useLocation)();
    var query = (0, _utils.queryToObject)(location['search']);
    return /*#__PURE__*/_react["default"].createElement(_Form["default"], {
      initialValues: {
        order: query['order'] || 'created',
        dateFrom: query['dateFrom'] || (0, _moment["default"])().subtract(1, 'months').format('YYYY-MM-DD 00:00:00'),
        dateTo: query['dateTo'] || (0, _moment["default"])().format('YYYY-MM-DD 23:59:59'),
        status: Number(query['status']) || -1,
        searchTerm: query['searchTerm'] || null,
        amountFrom: query['amountFrom'] || null,
        amountTo: query['amountTo'] || null,
        shopDemoMode: query['shopDemoMode'] || false
      },
      onSubmit: handleSubmit
    });
  } catch (e) {
    return /*#__PURE__*/_react["default"].createElement(_app.Error, {
      error: e
    });
  }
}

var _default = /*#__PURE__*/_react["default"].memo(Filter);

exports["default"] = _default;